/* rs-swish-favorites-migration.js - one-time copy of the old localStorage favourites into Swish.
   Contract, idempotency rules and REMOVAL date: header comment of snippets/rs-swish-favorites-migration.liquid,
   which loads this file. launch readiness pass 2, 2026-09-24: moved out of the inline <script>; loaded with `defer` (the work
   itself already waits for requestIdleCallback + the Swish helper, so timing is unchanged). Delete both together. */
(function () {
  var SRC = 'rs-favorites';
  var DONE = 'rs-favorites-migrated';

  function read(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return [];
      var val = JSON.parse(raw);
      return Array.isArray(val) ? val : [];
    } catch (e) {
      return [];
    }
  }

  // Cheap early exit: the overwhelming majority of page views do no work.
  var saved = read(SRC);
  if (!saved.length) return;

  var done = read(DONE);
  var pending = saved.filter(function (h) {
    return typeof h === 'string' && h && done.indexOf(h) === -1;
  });
  if (!pending.length) return;

  function markDone(handle) {
    try {
      var list = read(DONE);
      if (list.indexOf(handle) === -1) {
        list.push(handle);
        localStorage.setItem(DONE, JSON.stringify(list));
      }
    } catch (e) {}
  }

  // Swish boots asynchronously; wait for it rather than racing it.
  function whenReady(cb) {
    var waited = 0;
    var timer = setInterval(function () {
      if (window.WishlistKing && typeof window.WishlistKing.addWishlistItem === 'function') {
        clearInterval(timer);
        cb();
      } else if ((waited += 250) > 15000) {
        clearInterval(timer); // give up quietly; try again next page view
      }
    }, 250);
  }

  // Sequential, not parallel: this is a background courtesy, and a
  // visitor with 40 saves should not fire 40 concurrent requests.
  function migrate() {
    var i = 0;
    (function next() {
      if (i >= pending.length) return;
      var handle = pending[i++];
      fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product || !product.id) {
            // Product is gone (archived/unpublished). Mark it done so we
            // stop retrying a handle that will never resolve.
            markDone(handle);
            return null;
          }
          return window.WishlistKing.addWishlistItem({
            productHandle: handle,
            productId: product.id,
            inWishlist: false
          }).then(function () { markDone(handle); });
        })
        .catch(function () { /* leave unmarked; retried next page view */ })
        .then(function () { setTimeout(next, 300); });
    })();
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(function () { whenReady(migrate); }, { timeout: 5000 });
  } else {
    setTimeout(function () { whenReady(migrate); }, 1500);
  }
})();
